import React, {
	memo,
	useState,
	useEffect,
	useContext,
	useRef,
	useCallback,
} from "react";
import Modal from "./Modal";
import {
	Request,
	CTX_DISPATCH,
	creator,
	TCaptcha,
	uniqueString,
	isNumber,
} from "../common";
import "./styles/scss/Login.scss";
import phone from "./styles/scss/img/login/phone.png";
import code from "./styles/scss/img/login/code.png";
import crown from "./styles/scss/img/login/crown.png";

let isOnProcess = false;

function App(props) {
	const { isShow, onClose } = props;

	//网吧版兼容
	const isNetbar = window.mbQuery?.appInfo?.type === "netbar";

	const _dispatch = useContext(CTX_DISPATCH);
	const [loginType, setLoginType] = useState(isNetbar ? "wx" : "phone");
	const [time, setTime] = useState(-1); // -1: 初始状态  0: 过期
	const [wxTime, setWxTime] = useState(-1); // -1: 初始状态  0: 过期
	const [ticket, setTicket] = useState("");
	const [qrcodeUrl, setQrcodeUrl] = useState("");
	const [wxRefresh, setWxRefresh] = useState(0);
	const [msg, setMsg] = useState("");
	const [active, setActive] = useState("");
	const phoneRef = useRef(null);
	const codeRef = useRef(null);

	const sendCode = async () => {
		if (isOnProcess) return;

		const phone = phoneRef.current.value;

		if (phone === "" || !/^1[3,4,5,6,7,8,9]\d{9}$/.test(phone)) {
			setMsg("请输入正确手机号码");
			return;
		}

		//防抖
		isOnProcess = true;
		setTimeout(() => {
			isOnProcess = false;
		}, 3000);

		TCaptcha({ loading: false, needFeedBack: false }, async (res) => {
			if (res.ret === 0) {
				try {
					setTime(60);

					const req = new Request({
						url: "/user-center/user/userinfo/newjyz/sms",
						source: 1,
						method: "post",
						data: {
							phone,
							ticket: res.ticket,
							randstr: res.randstr,
						},
					});

					const _res = await req.send();

					if (_res.code !== 200) {
						throw new Error("error");
					}

					setMsg("验证码发送成功，请注意查收");
				} catch (error) {
					setTime(-1);
					setMsg("验证码发送失败，请联系客服");
				}
			}
		});
	};

	const submit = useCallback(async () => {
		try {
			const phone = phoneRef.current.value;
			const code = codeRef.current.value;

			if (phone === "" || !/^1[3,4,5,6,7,8,9]\d{9}$/.test(phone)) {
				setMsg("请输入正确手机号码");
				return;
			}

			if (!code) {
				setMsg("请先填写验证码");
				return;
			}

			const { barid, channel_number = "" } = window.mbQuery?.appInfo || {};

			let data = {
				ch_type: 0,
				phone,
				code,
				channel_number,
			};

			barid &&
				isNumber(barid) &&
				(data = {
					...data,
					ch_type: 1,
					channel_number: barid,
				});

			const req = new Request({
				url: "/user-center/user/userinfo/newjyz/login",
				source: 1,
				method: "post",
				data,
			});

			const res = await req.send();

			if (res.code === 200 && res.data?.token) {
				onClose();

				_dispatch(creator("setToken", res.data.token)); //触发token验证

				setMsg("");
			} else {
				setMsg(res.msg);
			}
		} catch (error) {
			setMsg("登录失败，请联系客服");
		}
	}, [_dispatch, onClose]);

	useEffect(() => {
		if (!isShow) return;

		const callback = (e) => {
			if (e.keyCode === 13) {
				submit();
			}
		};

		document.addEventListener("keydown", callback, false);

		return () => {
			document.removeEventListener("keydown", callback, false);
		};
	}, [isShow, submit]);

	useEffect(() => {
		if (!isShow) {
			//关闭窗口复原
			setWxTime(-1);
			phoneRef.current && (phoneRef.current.value = "");
			codeRef.current && (codeRef.current.value = "");
			return;
		}

		if (loginType === "wx") {
			const getData = async () => {
				try {
					const req = new Request({
						url: "/user-center/user/wxlogin/getQrCode",
						source: 1,
						data: {
							uuId: uniqueString(10),
						},
					});

					const res = await req.send();

					if (res.code === 200) {
						const ticket = res.data?.ticket;
						setTicket(ticket);
						setQrcodeUrl(
							`https://mp.weixin.qq.com/cgi-bin/showqrcode?ticket=${ticket}`
						);
						setWxTime(60);
					}
				} catch (error) {}
			};

			getData();
		}
	}, [isShow, loginType, wxRefresh]);

	useEffect(() => {
		var timer = setTimeout(() => {
			if (time > 0) {
				setTime((c) => c - 1);
			}
		}, 1000);

		return () => {
			clearTimeout(timer);
		};
	}, [time]);

	useEffect(() => {
		var timer = setTimeout(() => {
			if (wxTime > 0) {
				const getData = async () => {
					try {
						const req = new Request({
							url: "/user-center/user/wxlogin/check/login",
							source: 1,
							data: {
								qrcodeTicket: ticket,
							},
						});

						const res = await req.send();

						if (res.code === 200 && res.data?.token) {
							onClose();

							_dispatch(creator("setToken", res.data.token)); //触发token验证

							setWxTime(-1);
						} else {
							setWxTime((c) => c - 1);
						}
					} catch (error) {}
				};

				getData();
			}
		}, 1000);

		return () => {
			clearTimeout(timer);
		};
	}, [wxTime, _dispatch, onClose, ticket]);

	useEffect(() => {
		msg &&
			setTimeout(() => {
				setMsg("");
			}, 3000);
	}, [msg]);

	return (
		<Modal className="popup-login" visible={isShow} onClose={onClose}>
			<div className="left"></div>
			<div className="right">
				<div className="title">
					<div className="text">登录</div>
					<div className="flag">
						<img src={crown} alt="" />
						<span>首次登录领会员</span>
					</div>
				</div>
				<div className="box">
					{loginType === "phone" ? (
						<>
							<div
								className={`form-item phone${
									active === "phone" ? " active" : ""
								}`}
							>
								<img src={phone} alt="phone" />
								<input
									ref={phoneRef}
									type="text"
									onFocus={() => {
										setActive("phone");
									}}
									onBlur={() => {
										setActive("");
									}}
									placeholder="手机号"
								/>
							</div>
							<div
								className={`form-item code${
									active === "code" ? " active" : ""
								}`}
							>
								<div>
									<img src={code} alt="" />
									<input
										ref={codeRef}
										type="text"
										onFocus={() => {
											setActive("code");
										}}
										onBlur={() => {
											setActive("");
										}}
										placeholder="验证码"
									/>
								</div>
								<button
									type="button"
									className={`${time > 0 ? "disabled" : ""}`}
									disabled={time > 0}
									onClick={sendCode}
								>{`${time > 0 ? `${time}s` : `发送验证码`}`}</button>
							</div>
							<div className="msg" title={msg}>
								{msg}
							</div>
							<button type="button" className="login" onClick={submit}>
								登录
							</button>
						</>
					) : (
						<>
							<div className="qrcode-box">
								<div
									className="shadow"
									style={{ display: wxTime === 0 ? "flex" : "none" }}
								>
									<p>二维码已过期</p>
									<button
										onClick={() => {
											setWxRefresh(+new Date());
										}}
									>
										点击刷新
									</button>
								</div>
								<img src={qrcodeUrl} alt="" width={130} />
							</div>
							<div className="tips">微信扫码关注“玩家驿站”快速登录</div>
						</>
					)}
				</div>
				<div className="login-type-group">
					<button
						type="button"
						className={loginType === "phone" ? "active" : ""}
						onClick={() => {
							setLoginType("phone");
						}}
					></button>
					<button
						type="button"
						className={loginType === "wx" ? "active" : ""}
						onClick={() => {
							setLoginType("wx");
						}}
					></button>
				</div>
			</div>
		</Modal>
	);
}

export default memo(App);
